import './styles.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
if (!canvas) throw new Error('Missing #game-canvas element.');

const game = new Game(canvas);

// Title screen flow
const titleScreen = document.querySelector<HTMLElement>('#title-screen');
const startButton = document.querySelector<HTMLElement>('#start-button');
const touchControls = document.querySelector<HTMLElement>('#touch-controls');
const muteButton = document.querySelector<HTMLElement>('#mute-button');

const isTouch = window.matchMedia('(pointer: coarse)').matches;
if (isTouch) touchControls?.classList.add('active');

startButton?.addEventListener('click', () => {
  titleScreen?.classList.add('hidden');
  void game.resumeAudio();
  game.beginRace();
});

muteButton?.addEventListener('click', () => {
  const nowMuted = game.toggleMute();
  muteButton.textContent = nowMuted ? '🔇' : '🔊';
});

// Retry button + R restart
document.querySelector('#retry-button')?.addEventListener('click', () => {
  game.beginRace();
});
window.addEventListener('keydown', (e) => {
  if (e.code === 'KeyR') {
    titleScreen?.classList.add('hidden');
    game.beginRace();
  }
});

game.start();

if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
